import { createApp } from "vue";
import VueApexCharts from "vue3-apexcharts";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import { initAuth } from "./stores/authStore";
import "./firebase";
import "./styles/legal-pages.css";

initAuth();

const app = createApp(App);
app.use(i18n);
app.use(router);
app.use(VueApexCharts);
app.mount("#app");